export default "__VITE_ASSET__zCk62_1f__"